import { createSelector } from 'reselect'

import { getOrganizationsManagerState } from '../../../duck/selectors'
import { ADD_ORGANIZATION_MODAL_STORE_ID } from './types'

export const getAddOrganizationModalState = createSelector(
  getOrganizationsManagerState,
  (organizationsManagerState) => organizationsManagerState.components[ADD_ORGANIZATION_MODAL_STORE_ID]
)
